import { Flex, UnstyledButton } from "@sidelinesports/fan-design-system";
import type { ComponentProps } from "react";
import styles from "./MenuTriggerButton.module.css";

export const MenuTriggerButton = ({
  onClick,
  ...props
}: Omit<ComponentProps<typeof UnstyledButton>, "children">) => (
  <UnstyledButton
    aria-label="Game menu"
    className={styles["menu-trigger-button"]}
    type="button"
    onClick={onClick}
    {...props}
  >
    <div className={styles["shaded-circle"]} />
    <div className={styles["logo-box"]}>
      <div className={styles["team-logo"]} aria-hidden />
    </div>
    <Flex direction="column" gap={4}>
      <div className={styles.triangle} style={{ transform: "rotate(90deg)" }} />
    </Flex>
  </UnstyledButton>
);
